/*global Modernizr */
/*jslint browser:true */

(function() {
  'use strict';

  var accordions = document.querySelectorAll('.accordion');
  if(accordions) {
    accordions.forEach((accordion) => {
      var accordion_content = accordion.querySelector('.accordion-content'),
          accordion_button;

      if(!accordion.classList.contains('advanced')) {
        accordion_button = accordion.querySelector('.accordion-title');
      } else {
        accordion_button = accordion.querySelector('.accordion-toggle');
      }

      accordion_button.addEventListener('click', (e) => {
        e.preventDefault();

        var is_open = accordion.classList.contains('open');

        const toggleAccordion = () => {
          if(!is_open) {
            history.replaceState({}, null, window.location.pathname + '#' + accordion.getAttribute('id'));
            accordion.classList.add('open');
            accordion_button.setAttribute('aria-expanded', 'true');
            accordion_content.style.maxHeight = accordion_content.scrollHeight + "px";
          } else {
            history.replaceState({}, null, window.location.pathname);
            accordion.classList.remove('open');
            accordion_button.setAttribute('aria-expanded', 'false');
            accordion_content.style.maxHeight = null;
          }
        };

        // Fallback for browsers that don't support View Transitions:
        if (!document.startViewTransition) {
          toggleAccordion();
        } else {
          document.startViewTransition(() => toggleAccordion());
        }
      });

      window.addEventListener('resize', () => {
        var is_open = accordion.classList.contains('open');

        if(is_open) {
          accordion_content.style.maxHeight = accordion_content.scrollHeight + "px";
        }
      });
    });
  }
}());